import { navigateTo } from '@max/meituan-uni-navigate';
import { getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import { isXHSWebView } from "@msi/channel-basic";
import { navigateTo as xhsNavigateTo } from "@msi/api-xhs";
export const jumpToDetail = ({ goodInfo, index, supplyGroupId, pageSourceType, mcReport }) => {
    // 埋点上报
    mcReport('b_daodian_lowcode_c039w2ex_mc', {
        valLab: {
            deal_id: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId,
            biz_line: 'holiday',
            dealgroup_id: supplyGroupId,
            item_index: index
        }
    });
    // 参数校验
    if (!(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryId) || !(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId))
        return;
    const platformType = getPlatformType();
    const isInMTApp = platformType === PlatformType.mtApp || platformType === PlatformType.mtAppWebView;
    const isInDPApp = platformType === PlatformType.dpApp || platformType === PlatformType.dpAppWebView;
    const isTuangou = String(goodInfo.categoryId).startsWith('1006');
    const isInWxMtMiniProgram = platformType === PlatformType.mtMinaWebview;
    const isInWxTicketMiniProgram = platformType === PlatformType.mtTicketMinaWebview;
    const isInMtHotelMinaWebview = platformType === PlatformType.mtHotelMinaWebview;
    const getJumpUrl = () => {
        const baseParams = {
            categoryID: goodInfo.categoryId,
            productId: goodInfo.goodsId
        };
        if (isTuangou) {
            // 团购链接
            if (isXHSWebView) {
                // return `/pages/h5/index?f_openIdCipher=1&f_token=1&f_userId=1&f_openId=1&f_pos=0&weburl=http%253A%252F%252Fhfe-travelagencydealpages-featurefedo256636.awp.sankuai.com%2Fweb%2Findex.html%23%2F%3FcategoryID%3D${goodInfo.categoryId}%26productId%3D${goodInfo.goodsId}`;
                return `/pages/h5/index?f_openIdCipher=1&f_token=1&f_userId=1&f_openId=1&f_pos=0&weburl=https%3A%2F%2Fawp.meituan.com%2Fhfe%2Ftravel-agency-deal-pages%2Fweb%2Findex.html%23%2F%3FcategoryID%3D${goodInfo.categoryId}%26productId%3D${goodInfo.goodsId}`;
            }
            if (isInWxMtMiniProgram) {
                return `/ticket/pages/webview/index?url=https%3A%2F%2Fawp.meituan.com%2Fhfe%2Ftravel-agency-deal-pages%2Fweb%2Findex.html%23%2F%3FcategoryID%3D${goodInfo.categoryId}%26productId%3D${goodInfo.goodsId}`;
            }
            if (isInWxTicketMiniProgram) {
                return `/pages/webview/index?url=https%3A%2F%2Fawp.meituan.com%2Fhfe%2Ftravel-agency-deal-pages%2Fweb%2Findex.html%23%2F%3FcategoryID%3D${goodInfo.categoryId}%26productId%3D${goodInfo.goodsId}`;
            }
            if (isInMTApp) {
                return `imeituan://www.meituan.com/htmrn?mrn_biz=travel&mrn_entry=agency-deal-detail&mrn_component=agency_deal_detail&${new URLSearchParams(baseParams)}`;
            }
            if (isInDPApp) {
                return `dianping://htmrn?mrn_biz=travel&mrn_entry=agency-deal-detail&mrn_component=agency_deal_detail&${new URLSearchParams(baseParams)}`;
            }
            if (isInMtHotelMinaWebview) {
                return `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(`/ticket/pages/webview/index?url=https%3A%2F%2Fawp.meituan.com%2Fhfe%2Ftravel-agency-deal-pages%2Fweb%2Findex.html%23%2F%3FcategoryID%3D${goodInfo.categoryId}%26productId%3D${goodInfo.goodsId}`)}`;
            }
            // 外部浏览器唤起美团
            const mtUrl = `imeituan://www.meituan.com/htmrn?mrn_biz=travel&mrn_entry=agency-deal-detail&mrn_component=agency_deal_detail&${new URLSearchParams(baseParams)}`;
            return `https://w.dianping.com/cube/evoke/meituan.html?url=${encodeURIComponent(mtUrl)}`;
        }
        else {
            // 跟团链接
            if (isInMTApp) {
                let url = `imeituan://www.meituan.com/htmrn?mrn_biz=travel&mrn_entry=groupdeal&mrn_component=groupdeal&dealId=${goodInfo.goodsId}&pageSource=maker`;
                if (pageSourceType) {
                    url += `&pageSourceType=${pageSourceType}`;
                }
                return url;
            }
            if (isInDPApp) {
                let url = `dianping://web?url=https%3A%2F%2Fi.meituan.com%2Fhfe%2Fgroup-travel%2Fweb%2Fgroupdeal.html%3FdealId%3D${goodInfo.goodsId}%26pageSource%3Dmaker`;
                if (pageSourceType) {
                    url += `%26pageSourceType%3D${pageSourceType}`;
                }
                return url;
            }
            if (isInWxMtMiniProgram) {
                let url = `/ticket/pages/webview/index?url=https%3A%2F%2Fi.meituan.com%2Fhfe%2Fgroup-travel%2Fweb%2Fgroupdeal.html%3FdealId%3D${goodInfo.goodsId}%26pageSource%3Dmaker`;
                if (pageSourceType) {
                    url += `%26pageSourceType%3D${pageSourceType}`;
                }
                return url;
            }
            if (isInWxTicketMiniProgram) {
                let url = `/pages/webview/index?url=https%3A%2F%2Fi.meituan.com%2Fhfe%2Fgroup-travel%2Fweb%2Fgroupdeal.html%3FdealId%3D${goodInfo.goodsId}%26pageSource%3Dmaker`;
                if (pageSourceType) {
                    url += `%26pageSourceType%3D${pageSourceType}`;
                }
                return url;
            }
            if (isInMtHotelMinaWebview) {
                let url = `/ticket/pages/webview/index?url=https%3A%2F%2Fi.meituan.com%2Fawp%2Fh5%2Flvyou%2Fdeal%2Fgroup%2Findex.html%3FdealId%3D${goodInfo.goodsId}%26pageSource%3Dmaker`;
                if (pageSourceType) {
                    url += `%26pageSourceType%3D${pageSourceType}`;
                }
                return `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(url)}`;
            }
            // 外部浏览器唤起美团
            const mtUrl = `imeituan://www.meituan.com/htmrn?mrn_biz=travel&mrn_entry=agency-deal-detail&mrn_component=agency_deal_detail&${new URLSearchParams(Object.assign(Object.assign({}, baseParams), { pageSource: 'maker', pageSourceType }))}`;
            return `https://w.dianping.com/cube/evoke/meituan.html?url=${encodeURIComponent(mtUrl)}`;
        }
    };
    // 执行跳转
    const jumpUrl = getJumpUrl();
    if (isXHSWebView && isTuangou) {
        xhsNavigateTo({
            url: jumpUrl
        }).catch(err => {
            console.error('小红书小程序跳转失败', err);
        });
        return;
    }
    navigateTo({
        url: jumpUrl,
        _web: {
            miniProgramNative: true
        }
    });
};
